<template>
  <div class="commonSelect">
    <!-- h5Picker -->
    <van-field
      v-if="$isFlag"
      readonly
      clickable
      name="picker"
      style="border-radius:0"
      :label="selectionInfo.selectName"
      :value="area"
      placeholder="点击选择"
      @click="showArea = true"
    />
    <!-- web下拉 -->
    <div v-else class="selectWebClass">
      <p>{{ selectionInfo.selectName }}</p>
      <el-cascader
        ref="myCascader"
        v-model="area"
        :options="areaCascader"
        @change="handleChange"
      />
    </div>
    <!-- h5 popup -->
    <van-popup v-model="showArea" position="bottom">
      <van-area
        :area-list="areaList"
        :columns-num="2"
        @confirm="onConfirm"
        @cancel="showArea = false"
      />
    </van-popup>
  </div>
</template>
<script>
import { areaList } from '@vant/area-data'
export default {
  name: 'CommonSelect',
  props: {
    selectionInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }

  },
  data() {
    return {
      gameVal: '',
      area: '',
      showArea: false,
      areaList: areaList,
      areaCascader: []
    }
  },
  created() {},
  mounted() {
    const { city_list, province_list } = this.areaList
    for (const key in province_list) {
      const keyStr = String(key).substr(0, 2)
      const obj = {
        value: key,
        label: province_list[key],
        children: []
      }
      for (const j in city_list) {
        if (keyStr == String(j).substr(0, 2)) {
          obj.children.push({
            value: j,
            label: city_list[j]
          })
        }
      }
      this.areaCascader.push(obj)
    }
  },
  methods: {
    handleChange() {
      const obj = this.$refs.myCascader.getCheckedNodes()[0]
      const area = [
        { code: obj.parent.value, name: obj.parent.label },
        { code: obj.value, name: obj.label }
      ]
      const area2 = area[0].name + ' / ' + area[1].name
      this.$emit('emitAreaVal', area2, this.selectionInfo.key)
    },
    onConfirm(val) {
      if (val[0].name == val[1].name) {
        this.area = val[0].name
      } else {
        this.area = val[0].name + ' / ' + val[1].name
      }
      this.showArea = false
      this.$emit('emitAreaVal', this.area, this.selectionInfo.key)
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~assets/css/accountCommon.styl';

</style>
